import { DropdownForm } from 'components/fields';
import { STATES } from 'constants/states';
import { toPairs } from 'ramda';
import { FC } from 'react';

const stateOptions = toPairs(STATES).map(([code, name]) => ({
    label: name,
    value: code,
}));

interface Props {
    label: string;
    disabled?: boolean;
}

const StatesAutocomplete: FC<Props> = ({ label, disabled }) => {
    return (
        <DropdownForm id="select-state" label={label} name="state" options={stateOptions} required={true} isDisabled={disabled} />
    );
};

export { StatesAutocomplete };
